import React from "react";
import { Card, CardBody } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function KpiTile({
  value,
  unit,
  label,
  onClick,
  isLoading,
  isError,
  active,
  selectedIcon
}) {
  return (
    <Card
      onClick={onClick}
      role="button"
      tabIndex={0}
      className={`tile-card shadow-sm border border-lt ${active ? "tile-active" : ""}`}
      style={{ borderRadius: "0.5rem" }}
      onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onClick?.(e)}
    >
      <CardBody
        className="tile-card-body py-1"
        style={{
          display: "grid",
          gridTemplateRows: "1fr auto",
          minHeight: 120,
          padding: "0.75rem",
        }}
      >
        <div style={{ justifySelf: "center", alignSelf: "center", textAlign: "center" }}>
          {isLoading ? (
            <div className="fw-semibold">Loading…</div>
          ) : isError ? (
            <div className="text-danger">Error</div>
          ) : value != null ? (
            <div
              className="fw-semibold kpi-value"
            >
              {value}
              {unit ? <span className="ms-1">{unit}</span> : null}
            </div>
          ) : null}
        </div>

        {label && (
          <div className="kpi-tile-footer" >
            <span className="kpi-tile-icon " >
              <FontAwesomeIcon icon={selectedIcon} color="var(--brand-navy)" size="2x" />
            </span>
            <span className="kpi-tile-label text-muted" >
              {label}
            </span>
          </div>
        )}
      </CardBody>
    </Card>
  );
}
